import {createContext, useMemo, useRef, useState} from 'react';

const searchCategories = [
  {
    text: 'Invitations',
    urlFilterParam: 'invitation',
  },
  {
    text: 'eCards',
    urlFilterParam: 'card',
  },
];

const defaultContextValue = {
  searchQuery: '',
  // biome-ignore lint/suspicious/noEmptyBlockStatements: Fix me!
  setSearchQuery: () => {},
  searchCategories,
  searchCategory: 'Invitations',
  setSearchCategory: () => null,
  containerRef: {current: null},
};

export const SearchContext = createContext(defaultContextValue);

export const SearchContextParent = ({children}) => {
  const [searchCategory, setSearchCategory] = useState(
    window.location.href.includes('card') ? 'eCards' : 'Invitations'
  );
  const searchQuery = useRef('');
  const containerRef = useRef(null);

  const contextValue = useMemo(() => {
    const setSearchQuery = (val) => {
      searchQuery.current = val;
    };
    return {
      searchCategories,
      searchCategory,
      setSearchCategory,
      searchQuery,
      setSearchQuery,
      containerRef,
    };
  }, [searchCategory]);

  return <SearchContext.Provider value={contextValue}>{children}</SearchContext.Provider>;
};
